import { Event, RawServerEvent, MarkerData } from "./types"
// import { iconKey } from "@/common/globals"

/**
 * Parse a timestamp string from the server as UTC.
 * The server stores timestamps in UTC but returns them without timezone marker,
 * so we need to explicitly treat them as UTC to avoid local timezone interpretation.
 */
function parseServerTimestamp(timestamp: string | null): Date | null {
  if (!timestamp) return null
  // If the timestamp doesn't already have a timezone marker, treat it as UTC
  const utcTimestamp = timestamp.endsWith("Z") ? timestamp : timestamp + "Z"
  return new Date(utcTimestamp)
}

export function remapRawServerEvent(event: RawServerEvent): Event {
  const {
    event_start_timestamp,
    event_end_timestamp,
    created_at,
    updated_at,
    ...eventWithoutDateFields
  } = event

  return {
    ...eventWithoutDateFields,
    event_start_timestamp: parseServerTimestamp(event_start_timestamp)!,
    event_end_timestamp: parseServerTimestamp(event_end_timestamp) as Date,
    created_at: parseServerTimestamp(created_at)!,
    updated_at: parseServerTimestamp(updated_at)!,
  }
}

export function remapRawServerEvents(events: RawServerEvent[]): Event[] {
  return events.map(remapRawServerEvent)
}

export function markerDataFromEvents(events: Event[]): MarkerData[] {
  const markerData: MarkerData[] = events.map((event, index) => ({
    id: event.event_id,
    position: {
      lat: event.position.x,
      lng: event.position.y,
    },
    event_types: event.event_types,
    label: event.title,
    info: event.description,
    event_images: event.event_images ?? [],
    location_title: event.location_title,
    event_start_timestamp: event.event_start_timestamp,
    event_end_timestamp: event.event_end_timestamp,
    favorited: event.favorited,
    isPriority: index < 18,
  }))

  return markerData
}
